export default __webpack_public_path__ + "static/media/baton_gold.2bf7767a.jpg";